import { render, staticRenderFns } from "./qualityReport.vue?vue&type=template&id=72eb4472&scoped=true"
import script from "./qualityReport.vue?vue&type=script&lang=js"
export * from "./qualityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eb4472",
  null
  
)

export default component.exports